var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.937,
    height: 43.937,
    viewBox: "0 0 43.937 43.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3b1716;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vias",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-1",
    d: "M145.609,156a11.843,11.843,0,0,0-10.9,16.476h-8.824v-4.462a.858.858,0,1,0-1.716,0v5.32a.858.858,0,0,0,.858.858h10.589a11.889,11.889,0,0,0,.795,1.106c.014.02.027.039.043.058l7.4,9.476h-4.023a.858.858,0,0,0,0,1.716h11.589a.858.858,0,0,0,0-1.716h-4.05L154.8,175.3l.009-.012a11.839,11.839,0,0,0-9.2-19.288Zm7.853,18.235-.031.039L145.609,184.3l-7.742-9.919a.894.894,0,0,0-.069-.1,10.126,10.126,0,1,1,15.664-.052Z",
    transform: "translate(-113.514 -142.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-1",
    d: "M305.781,218.853a.858.858,0,0,0-1.63.526,5.321,5.321,0,1,1-3.629-3.489.858.858,0,0,0,.457-1.655,7.037,7.037,0,1,0,4.805,4.617Z",
    transform: "translate(-266.988 -195.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-1",
    d: "M416.4,235.33l-.006-.009a.858.858,0,1,0-1.213,1.214l.008.008a.858.858,0,1,0,1.214-1.214Z",
    transform: "translate(-379.323 -214.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-1",
    d: "M20.109,420H.858a.858.858,0,0,0,0,1.716H19.251v5.32a.858.858,0,1,0,1.716,0v-6.179A.858.858,0,0,0,20.109,420Z",
    transform: "translate(0 -383.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-1",
    d: "M15.659,0A.858.858,0,0,0,14.8.858V7.037H.858a.858.858,0,0,0,0,1.716h14.8a.858.858,0,0,0,.858-.858V.858A.858.858,0,0,0,15.659,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-1",
    d: "M8.367,154H1.858a.858.858,0,1,0,0,1.716H7.509v14.932H1.858a.858.858,0,1,0,0,1.716H8.367a.858.858,0,0,0,.858-.858V154.858A.858.858,0,0,0,8.367,154Z",
    transform: "translate(-0.914 -140.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-1",
    d: "M125.634,251.253a.858.858,0,1,0,.251.607A.858.858,0,0,0,125.634,251.253Z",
    transform: "translate(-113.513 -229.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-1",
    d: "M135.483,154H125.028a.858.858,0,0,0-.858.858v4.763a.858.858,0,1,0,1.716,0v-3.9h9.6a.858.858,0,1,0,0-1.716Z",
    transform: "translate(-113.514 -140.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-1",
    d: "M236.178,0a.858.858,0,0,0-.858.858V7.037h-12.8V.858a.858.858,0,0,0-1.716,0V7.895a.858.858,0,0,0,.858.858h14.52a.858.858,0,0,0,.858-.858V.858A.858.858,0,0,0,236.178,0Z",
    transform: "translate(-201.852 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M443.492,7.037h-3.776V.858a.858.858,0,0,0-1.716,0V7.895a.858.858,0,0,0,.858.858h4.634a.858.858,0,0,0,0-1.716Z",
    transform: "translate(-400.413 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-1",
    d: "M463.988,154h-2.71a.858.858,0,0,0,0,1.716h2.71a.858.858,0,0,0,0-1.716Z",
    transform: "translate(-420.909 -140.785)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVias);
export default __webpack_public_path__ + "static/media/Vias.8052a7d69cfdaf93c9da05f96b03bc7e.svg";
export { ForwardRef as ReactComponent };